import React from "react";

import { LazyRemote } from "widgets/lazyremote";
import { ErrorBoundary } from "widgets/layouts";

import { BaseComponent, PublicRoute } from "../components/base/index.jsx";

export function CustomFormFieldShowcase() {
  return (
    <ErrorBoundary>
      <BaseComponent baseName="/customcomponent">
        <PublicRoute path="/" baseRedirect={true}>
          <LazyRemote
            name="application"
            module="kfapplication/customformfieldshowcase"
            componentName="CustomFormFieldShowcase"
            key="AppNavigation"
          />
        </PublicRoute>
      </BaseComponent>
    </ErrorBoundary>
  );
}
